module.exports = __webpack_public_path__ + "taiga-logo.png";